<template>
	<el-row class="points-show">
		<el-col :span="23">
			知识点库
		</el-col>
		<el-divider></el-divider>
		<div>
			<el-col :span="3" style=" display: block;">
				<div class="padding-xs text-bold">品类分类</div>
				<div class="margin-tb-xsm">
					<el-input placeholder="筛选" size="mini" v-model="screenCategory" @input="screenCategoryChange">
						<i slot="suffix" class="el-input__icon el-icon-search" @click="screenCategoryChange"></i>
					</el-input>
				</div>
				<el-radio-group v-model="currentCategory" @change="currentCategoryChange">
					<el-radio class="margin-tb-xsm" border size="mini" v-for="(item, index) in CategoryLabelList"
						v-if="item.isShow === undefined || item.isShow" :label="index">
						{{ item.dicDesc }}
					</el-radio>
				</el-radio-group>
			</el-col>
			<el-col :span="20" :offset="1">
				<el-tabs v-model="activeName" @tab-click="handleActiveClick" style="width:100%">
					<el-tab-pane label="通用知识" name="knowledge">
						<el-col :span="19" class="padding-top-sm">
							<div style="width:100%">
								<div>
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
											<span class="bread-item" @click="onIndexFolder(index)">
												{{ item.name }}
											</span>
										</el-breadcrumb-item>
									</el-breadcrumb>
								</div>
								<div style="margin-top:16px">
									<div class="file-box">
										<div class="name" style="cursor:auto;">
											名称
										</div>
										<div class="createdtime">
											创建时间
										</div>
										<!-- <div class="file-type">
                                    文件类型
                                </div> -->
										<div class="file-cz">操作</div>
									</div>
									<template v-if="dataList.length > 0">
										<div class="file-box" v-for="(item, index) in dataList" :key="index">
											<div class="name">
												<img style="margin-right:10px" :src="item.knowledgeIcon" alt="" />
												<span @click="nextIndex(index)" v-if="!item.isRename">
													{{ item.fileName }}</span>
												<input v-else type="text" :name="item.fileName"
													v-model="item.fileName" />
											</div>
											<div class="createdtime">
												{{ item.createTime }}
											</div>
											<div class="file-type">
												{{ item.fileType | getfileType }}
											</div>
											<div class="file-cz">
												<template v-if="item.fileType == null">
													<el-button v-if="!item.isRename" type="text" size="mini"
														@click="editFolder(index)">
														重命名
													</el-button>
													<el-button v-else type="text" size="mini"
														@click="isOkEditFolderName(index)">
														确定
													</el-button>
													<el-button type="text" size="mini"
														@click="LabelManagement(index, 'folder')">
														编辑
													</el-button>
													<el-button type="text" size="mini"
														@click="isOkEditFolderName(index, 'remove')">
														移除文件夹
													</el-button>
												</template>

												<template v-else>
													<el-button type="text" size="mini" @click="seeWenjian(index)">
														下载文件
													</el-button>
													<el-button type="text" size="mini"
														@click="LabelManagement(index, 'file')">
														编辑标签
													</el-button>
													<el-button type="text" size="mini" @click="removeKnowlege(index)">
														移除文件
													</el-button>
												</template>
											</div>
										</div>
									</template>
									<div v-else style="text-align:center;padding:50px 0;color:#666;font-size:15px">
										这是一个空文件夹呦！！
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="3" class="padding-top">
							<div>
								<el-link class="block" icon="el-icon-edit" @click="updataModes()">上传文件</el-link>
								<el-divider></el-divider>
								<el-link class="block margin-top-xs" icon="el-icon-edit" @click="uploadWenjian()">创建文件夹
								</el-link>
							</div>
						</el-col>
					</el-tab-pane>
					<el-tab-pane label="营销讲解" name="explain">
						<el-col :span="19">
							<el-table :data="ExplainList" style="width: 100%">
								<el-table-column prop="name" label="讲解主题">
									<template slot-scope="scope">
										<el-link class="block" icon="el-icon-s-comment"
											@click="GetExplainInfoList(scope.row.id, scope.row.wxIcon)">
											{{ scope.row.name }}
										</el-link>
									</template>
								</el-table-column>
								<el-table-column prop="id" label="主题图片">
									<template slot-scope="scope">
										<el-image style="width: 80px; height: 60px" :src="scope.row.explainIcon">
										</el-image>
									</template>
								</el-table-column>
								<el-table-column prop="nickName" label="讲解导师">
								</el-table-column>
								<el-table-column prop="goodsTitle" label="关联商品">
								</el-table-column>
								<el-table-column prop="createTime" label="上传日期">
								</el-table-column>
								<el-table-column prop="viewsNum" label="浏览量">
								</el-table-column>
								<el-table-column prop="status" label="状态" width="200">
									<template slot-scope="scope">
										<el-switch slot="reference" v-model="scope.row.status == 0"
											active-color="#13ce66" inactive-color="var(--grey)" active-text="上架"
											inactive-text="下架" @change="changesale(scope.row.id, scope.row.status)" />
									</template>
								</el-table-column>
								<el-table-column prop="status" label="编辑" width="200">
									<template slot-scope="scope">
										<el-button type="info" size="mini" @click="edites(scope.row)">编辑</el-button>
										<el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
						<el-col :span="3" class="padding-top" :offset="1">
							<div>
								<el-link class="block" icon="el-icon-s-comment" @click="openExplainDialog">创建一个新的讲解
								</el-link>
								<el-divider></el-divider>
							</div>
						</el-col>
					</el-tab-pane>
					<el-tab-pane label="社群连载" name="community">
						<el-col :span="19">
							<el-table :data="communityList" style="width: 100%">
								<el-table-column prop="title" label="文章主题">
								</el-table-column>
								<el-table-column prop="id" label="文章图片">
									<template slot-scope="scope">
										<el-image style="width: 80px; height: 60px" :src="scope.row.titleImg">
										</el-image>
									</template>
								</el-table-column>
								<el-table-column prop="comInfoTitle" label="文章内容">
								</el-table-column>
								<el-table-column prop="createTime" label="上传日期">
								</el-table-column>
								<el-table-column prop="status" label="状态">
									<template slot-scope="scope">
										<el-switch slot="reference" v-model="scope.row.status == 0"
											active-color="#13ce66" inactive-color="var(--grey)" active-text="上架"
											inactive-text="下架" @change="changesale2(scope.row.id, scope.row.status)" />
									</template>
								</el-table-column>
								<el-table-column prop="fileType" label="操作" width="160">
									<template slot-scope="scope">
										<el-button size="mini" plain type="primary" @click="editCommunity(scope.row)">编辑
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
						<el-col :span="3" class="padding-top" :offset="1">
							<div>
								<el-link class="block" icon="el-icon-s-comment" @click="openCommunityDialog">创建新文章
								</el-link>
								<el-divider></el-divider>
							</div>
						</el-col>
					</el-tab-pane>
					<el-tab-pane label="品类文案" name="doc">
						<el-col :span="19">
							<el-table :data="docList" style="width: 100%">
								<el-table-column prop="matId" label="素材ID" />
								<el-table-column label="素材图片">
									<template slot-scope="scope">
										<el-image
											:src="docList[scope.$index].matImg.split(',')[0] + '?x-oss-process=image/resize,w_50'"
											style="width: 50px; height: 50px" fit="cover"
											:preview-src-list="docList[scope.$index].matImg.split(',')" />
									</template>
								</el-table-column>
								<el-table-column prop="matInfoTitle" label="素材文案" />
								<el-table-column prop="contentTypeText" label="内容类型" />
								<el-table-column prop="matTextTypeText" label="素材类型" />
								<el-table-column prop="status" label="素材修改" width="230px">
									<template slot-scope="scope">
										<el-button size="mini" @click="updateScattered(scope.row)">
											编辑素材

										</el-button>
										<el-button type="danger" size="mini" icon="el-icon-delete" circle
											@click="removeMat(scope.row.matId, 1)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
						<el-col :span="3" class="padding-top" :offset="1">
							<div>
								<el-link class="block" icon="el-icon-s-comment" @click="productAttrAdd">创建新文案</el-link>
								<el-divider></el-divider>
							</div>
						</el-col>
					</el-tab-pane>
				</el-tabs>
			</el-col>
			<!-- 创建一个新的讲解嗷 -->
			<el-col :span="24">
				<el-dialog title="讲解" :visible.sync="ExplainDialog" width="30%" :before-close="closeExplainDialog">
					<el-form :model="ExplainForm" ref="ExplainForm" label-width="100px">
						<el-form-item label="讲解主题">
							<el-input type="text" size="mini" v-model="ExplainForm.name"></el-input>
						</el-form-item>
						<el-form-item label="主题图片">
							<el-button @click="opendrawer(0)" type="primary" size="mini" style="margin-bottom: 10px;">
								图片库上传
							</el-button>
							<template v-if="ExplainForm.explainIcon">
								<div style="display: flex;align-items: center;">
									<el-image style="width: 150px;height: 150px;"
										:src="ExplainForm.explainIcon"></el-image>
									<el-button style="margin-left: 10px;" type="danger" icon="el-icon-delete" circle
										size="mini" @click="ExplainForm.explainIcon = ''"></el-button>
								</div>
							</template>
							<!-- <el-upload :class="{ hide: hide }" :action="uploadUrl" list-type="picture-card" :limit="1"
                                accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="ExplainFile" :on-success="getPictrueURL"
                                :on-preview="handlePictureCardPreview" :on-error="handleError" :multiple="true"
                                :on-exceed="handleOverImage">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog append-to-body :visible.sync="dialogDisplay" @close="imagePrevClosed" size="tiny">
                                <img width="100%" :src="dialogImageUrl" alt="" />
                            </el-dialog> -->
						</el-form-item>
						<el-form-item label="选择商品">
							<el-input size="mini" v-model="ExplainForm.productName" :disabled="true"
								style="width:215px" />
							<el-button size="mini" @click="table = true">查询商品</el-button>
						</el-form-item>
						<!-- <el-form-item label="扩充标签操作">
                            <el-tag :key="tag.sid" v-for="tag in KcFlagForm.kcFlagList" closable
                                :disable-transitions="false" @close="removeKcFlag(tag)">
                                {{ tag.fname }}->{{ tag.sname }}
                            </el-tag>
                             展示应有的扩充标签 
                        </el-form-item>
                        <el-form-item label="选择标签">
                            <el-select size="mini" style="width:260px !important;" filterable v-model="KcFlagFatherIndex"
                                placeholder="请选择大类标签" @change="KcFlagFatherChange()">
                                <el-option v-for="(item, index) in KcFlagFatherList" :key="index" :label="item.dicDesc"
                                    :value="index">
                                </el-option>
                            </el-select>
                            <i class="el-icon-d-arrow-right" style="padding:0 10px"></i>
                            <el-select size="mini" style="width:260px !important;" filterable v-model="KcFlageSunIndex"
                                placeholder="请选择类属标签">
                                <el-option v-for="(item, index) in KcFlagSunList[KcFlagFatherId]" :key="index"
                                    :label="item.dicDesc" :value="index">
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="mini" style="margin-left:20px" @click="addKcFlag()">增加
                            </el-button>
                        </el-form-item>-->
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="closeExplainDialog">取 消</el-button>
						<el-button size="mini" type="primary" @click="InsertExplain()">确 定</el-button>
					</span>
				</el-dialog>
			</el-col>
			<!-- 上传社群连载 -->
			<el-col :span="24">
				<el-dialog title="社群连载" :visible.sync="CommunityDialog" width="800px"
					:before-close="closeCommunityDialog">
					<el-form :model="CommunityForm" ref="ExplainForm" label-width="100px">
						<el-form-item label="文章主题">
							<el-input type="text" size="mini" v-model="CommunityForm.title"></el-input>
						</el-form-item>
						<el-form-item label="主题图片">
							<el-upload :action="uploadUrl" list-type="picture-card" :limit="1"
								accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="CommunityFile"
								:on-success="getPictrueURL2" :on-preview="handlePictureCardPreview"
								:on-error="handleError" :multiple="true" :on-exceed="handleOverImage">
								<i class="el-icon-plus"></i>
							</el-upload>
							<el-dialog append-to-body :visible.sync="dialogDisplay" @close="imagePrevClosed"
								size="tiny">
								<img width="100%" :src="dialogImageUrl" alt="" />
							</el-dialog>
						</el-form-item>
						<el-form-item label="文章内容">
							<wangeditor v-model="CommunityForm.comInfo" style="width:100%;margin:0;" ref="wangeditor" />
						</el-form-item>
						<el-form-item label="扩充标签操作">
							<el-tag :key="tag.sid" v-for="tag in KcFlagForm.kcFlagList" closable
								:disable-transitions="false" @close="removeKcFlag(tag)">
								{{ tag.fname }}->{{ tag.sname }}
							</el-tag>
							<!-- 展示应有的扩充标签 -->
						</el-form-item>
						<el-form-item label="选择标签">
							<el-select size="mini" style="width:260px !important;" filterable
								v-model="KcFlagFatherIndex" placeholder="请选择大类标签" @change="KcFlagFatherChange()">
								<el-option v-for="(item, index) in KcFlagFatherList" :key="index" :label="item.dicDesc"
									:value="index">
								</el-option>
							</el-select>
							<i class="el-icon-d-arrow-right" style="padding:0 10px"></i>
							<el-select size="mini" style="width:260px !important;" filterable v-model="KcFlageSunIndex"
								placeholder="请选择类属标签" @change="KcFlagSunChange()">
								<el-option v-for="(item, index) in KcFlagSunList[KcFlagFatherId]" :key="index"
									:label="item.dicDesc" :value="index">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="closeCommunityDialog">取 消</el-button>
						<el-button size="mini" type="primary" v-if="comLag == 'insert'" @click="InsertCommunity()">确 定
						</el-button>
						<el-button size="mini" type="primary" v-if="comLag == 'update'" @click="UpdateCommunity()">编 辑
						</el-button>
					</span>
				</el-dialog>
			</el-col>
			<!-- 新建文件夹 -->
			<el-col :span="24">
				<el-dialog title="文件夹操作" :visible.sync="dialogVisible" width="30%" :before-close="openOrCloseMode">
					<!-- 这里选择标签。 -->
					<el-form :model="KcFlagForm" ref="KcFlagForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="文件夹名称">
							<el-input style="width:100%" v-model="floter.folderName" placeholder="请输入文件夹名称" size="mini">
							</el-input>
						</el-form-item>
						<el-form-item label="扩充标签操作">
							<el-tag :key="tag.sid" v-for="tag in KcFlagForm.kcFlagList" closable
								:disable-transitions="false" @close="removeKcFlag(tag)">
								{{ tag.fname }}->{{ tag.sname }}
							</el-tag>
							<!-- 展示应有的扩充标签 -->
						</el-form-item>
						<el-form-item label="选择标签">
							<el-select size="mini" style="width:260px !important;" filterable
								v-model="KcFlagFatherIndex" placeholder="请选择大类标签" @change="KcFlagFatherChange()">
								<el-option v-for="(item, index) in KcFlagFatherList" :key="index" :label="item.dicDesc"
									:value="index">
								</el-option>
							</el-select>
							<i class="el-icon-d-arrow-right" style="padding:0 10px"></i>
							<el-select size="mini" style="width:260px !important;" filterable v-model="KcFlageSunIndex"
								placeholder="请选择类属标签">
								<el-option v-for="(item, index) in KcFlagSunList[KcFlagFatherId]" :key="index"
									:label="item.dicDesc" :value="index">
								</el-option>
							</el-select>
							<el-button type="primary" size="mini" style="margin-left:20px" @click="addKcFlag()">增加
							</el-button>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="openOrCloseMode">取 消</el-button>
						<el-button size="mini" type="primary" @click="addFloter()">确 定</el-button>
					</span>
				</el-dialog>
			</el-col>
			<!-- 上传品类文案 -->
			<el-col :span="24">
				<!-- 素材表单 -->
				<el-dialog title="上传文案" :visible.sync="dialogFormVisible" :before-close="closeUpdate" width="32%">
					<el-form :model="form">
						<el-form-item label="图片/视频" prop="matImg">
							<el-upload :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="20"
								:on-success="getPictrueURL" accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
								:on-preview="handlePictureCardPreview" :on-remove="handleRemove"
								:on-error="handleError">
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">
									只能上传jpg/png文件，最多上传20张图片
								</div>
								<div slot="tip" class="el-upload__tip">
									当前已上传：{{ form.matImg.split(",").length - 1 }}
								</div>
							</el-upload>
							<el-dialog :visible.sync="dialogDisplay" @close="imagePrevClosed" size="tiny"
								append-to-body>
								<video v-if="dialogImageUrl.substring(0, 4) == 'blob'" :src="dialogImageUrl"
									class="avatar" controls="controls">您的浏览器不支持视频播放</video>
								<img v-else width="100%" :src="dialogImageUrl" alt="">
							</el-dialog>
						</el-form-item>

						<el-form-item label="文案/话术">
							<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.matInfo">
							</el-input>
						</el-form-item>
						<!-- 999999999999 -->
						<el-card class="box-card" v-model="form.contentType = 125">
							<div slot="header" class="clearfix">
								<span>内容类型：产品种草</span>
							</div>
							<el-form-item label="素材类型：知识科普" v-model="form.matTextType = 41">
							</el-form-item>
							<el-form-item label="关联品类">
								<el-select v-model="form.matVariety" filterable size="mini" placeholder="请搜索">
									<el-option v-for="item in matVarietyList" :key="item.dicId" :label="item.dicDesc"
										:value="item.dicId">
									</el-option>
								</el-select>
							</el-form-item>
						</el-card>


						<!-- <el-form-item label="素材类型" >
                <el-select v-model="form.matTextType" filterable size="mini" placeholder="请搜索">
                    <el-option
                    v-for="item in selectDicList"
                    :key="item.dicId"
                    :label="item.dicDesc"
                    :value="item.dicId">
                    </el-option>
                </el-select>
            </el-form-item> -->

					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button size="mini" @click="closeUpdate">取 消</el-button>
						<el-button size="mini" type="primary" @click="addScattered">确 定</el-button>
					</div>
				</el-dialog>
			</el-col>
			<!-- 上传文件 -->
			<el-col :span="24">
				<el-dialog title="上传文件" :visible.sync="dialogVisible2" width="30%" :before-close="updataModes">
					<!-- 这里选择标签。 -->
					<el-form :model="KcFlagForm" ref="KcFlagForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="扩充标签操作">
							<el-tag :key="tag.sid" v-for="tag in KcFlagForm.kcFlagList" closable
								:disable-transitions="false" @close="removeKcFlag(tag)">
								{{ tag.fname }}->{{ tag.sname }}
							</el-tag>
							<!-- 展示应有的扩充标签 -->
						</el-form-item>
						<el-form-item label="选择标签">
							<el-select size="mini" style="width:260px !important;" filterable
								v-model="KcFlagFatherIndex" placeholder="请选择大类标签" @change="KcFlagFatherChange()">
								<el-option v-for="(item, index) in KcFlagFatherList" :key="index" :label="item.dicDesc"
									:value="index">
								</el-option>
							</el-select>
							<i class="el-icon-d-arrow-right" style="padding:0 10px"></i>
							<el-select size="mini" style="width:260px !important;" filterable v-model="KcFlageSunIndex"
								placeholder="请选择类属标签">
								<el-option v-for="(item, index) in KcFlagSunList[KcFlagFatherId]" :key="index"
									:label="item.dicDesc" :value="index">
								</el-option>
							</el-select>
							<el-button type="primary" size="mini" style="margin-left:20px" @click="addKcFlag()">增加
							</el-button>
						</el-form-item>
						<el-form-item label="上传文件" v-if="file.knowledgeId == null">
							<el-upload class="upload-demo" :action="uploadUrl" :on-success="handleChange"
								:on-error="handleError" :multiple="true" :file-list="fileList"
								v-if="file.knowledgeId == null && KcFlagForm.kcFlag != ''">
								<el-button size="mini" type="success" round>上传文件</el-button>
							</el-upload>
							<div v-if="file.knowledgeId == null && KcFlagForm.kcFlag == ''">
								请选择完成扩充标签之后再进行上传操作。
							</div>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="updataModes">取 消</el-button>
						<el-button size="mini" type="primary" @click="updateFileKCFlag">确 定</el-button>
					</span>
				</el-dialog>
			</el-col>
			<!-- 查询商品 -->
			<el-col :span="24">
				<el-drawer title="查询商品" :visible.sync="table" direction="rtl" size="50%" style="overflow: auto;">
					<div style="margin-top:20px;margin-bottom:20px;overflow: auto;">
						<span style="margin:20px;">商品名称</span>
						<el-input v-model="keyword" size="mini" style="width:200px;margin-right:20px;" />
						<el-button size="small" @click="searchProduct(true)">
							搜索
						</el-button>
					</div>
					<div>
						<div style="overflow: auto;">
							<el-table :data="tableDataProduct" border style="width: 99%">
								<el-table-column prop="id" label="商品id" align="center" />
								<el-table-column prop="goodsCode" label="货号" align="center" />
								<el-table-column label="缩略图" align="center">
									<template slot-scope="scope">
										<el-image :src="scope.row.goodsLogo.split(',')[0] +
                                            '?x-oss-process=image/resize,w_50'
                                            " fit="fill" :preview-src-list="scope.row.preview" />
									</template>
								</el-table-column>
								<el-table-column prop="goodsTitle" label="商品名称" align="center" />
								<el-table-column prop="goodsPrice" label="价格" align="center" />
								<el-table-column label="上架状态" align="center">
									<template slot-scope="scope">
										<span>{{ scope.row.status == 1 ? "已上架" : "下架" }}</span>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="danger" size="mini" @click="clickProductIs(scope.row)">
											选择
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
						:page-size="pageSize2" :page-sizes="[30, 50, 100]" :total="total2" :current-page.sync="pageNum2"
						@size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
				</el-drawer>
			</el-col>
			<!-- 创建一个对话框，像QQ WX那样。尴尬 -->
			<el-col :span="24">
				<el-dialog title="讲解~" :visible.sync="ExplainHoverDiolag">
					<div class="Message-shadow">
						<div class="Message-list">
							<div v-for="(item, index) in ExplainHoverList" class="Message-info new_message"
								id="new_message" name="new_message">
								<!-- 最前面的删除按钮 -->
								<div style="padding: 10px;">
									<el-button type="danger" icon="el-icon-delete" circle size="mini"
										@click="removeMessage(item.id)"></el-button>
									<el-button type="primary" icon="el-icon-edit" circle size="mini"
										@click="editeMessage(item)"> </el-button>
								</div>
								<div class="Message-info-msg">
									<!-- 判断类型 -->
									<div v-if="item.type == 'content'">{{ item.content }}</div>
									<div v-else-if="item.type == 'jpg' || item.type == 'png'">
										<img class="Message-info-image" :src="item.content" alt="">
									</div>
									<div v-else-if="item.type == 'mp4'">
										<video :src="item.content" controls="controls" style="width:300px">
										</video>
									</div>
								</div>
								<div style="padding-right:20px"><img class="Message-user-icon"
										src="https://img.xinian727.cn/qunce2/zsshare.png"></div>
							</div>
						</div>
						<div class="Message-input">
							<!-- 图片以及视频消息 -->
							<div style="display: flex;align-items: center;">
								<!-- <el-upload :action="uploadUrl" list-type="unset" :limit="10" accept=".jpg,.png,.mp4"
                                    :on-success="handleUploadMsg" :show-file-list="false" :multiple="true">
                                    <i class="el-icon-picture" style="font-size: 26px;padding: 5px 20px;"></i>
                                     <i class="el-icon-camera-solid" style="font-size: 26px;padding: 5px 5px;"></i> 
                                </el-upload>-->
								<el-button icon="el-icon-camera-solid" circle @click="opendrawer(1)" size="mini"
									type="primary"></el-button>
							</div>
							<div>
								<el-input type="textarea" :rows="3" :autofocus="true" v-model="ExplainInfoText">
								</el-input>
							</div>
							<div style="width:100%;display: flex;justify-content: flex-end;">
								<el-button style="margin-right: 8px;margin-top:4px" size="mini"
									@click="sendTextMessage">发送</el-button>
							</div>
						</div>
					</div>
				</el-dialog>
			</el-col>
		</div>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</el-col>
		<el-drawer title="图片选择" :visible.sync="drawer" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script>
	import httpClient from "../../../util/request.js";
	import wangeditor from '../../../components/wangEditor/wangEditor.vue';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture,
			wangeditor
		},
		data() {
			return {
				czType: null,
				drawerType: null,
				hide: false,
				drawer: false,
				table: false,
				activeName: "knowledge",
				dialogType: '',
				dialogFormVisible: false,
				breadList: [],
				uploadUrl: httpClient.imgUrl,
				props: {
					label: "fileName",
					children: "children",
					isLeaf: "isFolder",
				},
				fileList: [],
				dataList: [],
				floterName: "",
				data: {},
				knowledgeId: -1,
				dialogVisible: false,
				dialogVisible2: false,
				pointsImgList: [
					"http://img.xinian727.cn/paibo/sys/folder.png",
					"http://img.xinian727.cn/paibo/sys/excel.png",
					"http://img.xinian727.cn/paibo/sys/word.png",
					"http://img.xinian727.cn/paibo/sys/ppt.png",
					"http://img.xinian727.cn/paibo/sys/image.png",
				],
				// 品类标签
				CategoryLabelList: [],
				// 当前选中的品类标签
				currentCategory: 0,
				screenCategory: "",
				// 品类查询字段。---
				searchLabel: "",
				// 进行文件或者文件夹的KC_flage update
				// 文件或者文件夹标签扩充
				KcFlagFatherList: [],
				KcFlagSunList: {},
				KcFlagDrawer: false,
				KcFlagForm: {
					kcFlag: "",
					kcFlagList: [],
				},
				KcFlagFatherId: null,
				KcFlagFatherIndex: null,
				KcFlageSunIndex: null,
				// 文件夹 编辑
				operationType: "", // 标识 状态
				floter: {
					folderName: "",
					folderId: -1,
					kcFlag: null,
					folderId: null,
				},
				file: {
					fileName: "",
					filePath: "",
					fileType: "",
					folderId: -1,
					kcFlag: null,
					knowledgeId: null,
				},
				// ==================营销讲解
				// ==================
				// ==================
				ExplainFile: [], // 商品图片上传控件图片数据源
				dialogDisplay: false, // 上传图片弹窗
				dialogImageUrl: "", //上传图片控件预览url、
				communityList: [],
				docList: [],
				ExplainList: [],
				ExplainDialog: false,
				ExplainForm: {
					id: null,
					name: "",
					productId: null,
					productName: "",
					explainIcon: "",
					kcFlag: null,
					status: 0,
					deleteStatus: 0,
					memberId: 1,
				},
				//社群连载 ===============表单
				comLag: null,
				CommunityDialog: false,
				CommunityFile: [],
				CommunityForm: {
					id: null,
					title: "",
					comInfo: "",
					titleImg: "",
					kcFlag: null,
					status: 0,
					deleteStatus: 0,
				},

				keyword: '',
				pageNum2: 1,
				pageSize2: 15,
				pageNum: 1,
				pageSize: 100,
				tableDataProduct: [],
				total: 0,
				total2: 0,
				//   ================以下是一个大活嗷
				//   ================
				//   ================
				ExplainId: null,
				ExplainIcon: '',
				ExplainHoverList: [],
				ExplainHoverDiolag: false,
				ExplainInfoFileList: [],
				ExplainInfoText: '',

				//品类文案同步到产品种草下的知识科普
				form: {
					matId: '', //素材的ID
					matImg: '', //图片或视频地址
					matInfo: '', //文案或者话术
					matPicType: '',
					matTextType: '',
					matRange: '',
					matStage: '',
					productName: '请查询商品并选择', //商品名称
					productId: 0, //商品ID
					matStyle: 1,
					status: 0,
				},
				matVarietyList: [],
				matVariety: '',
				contentTypeList: [],
				contentType: '',
				matStyle: 1,
				KcFlageSunId: null,
				editeMessageItem: {}
			};
		},
		created() {
			this.getPoints(this.knowledgeId, 0);
			this.getP181Label(181);
			this.getGroupFatherList(-1, "知识点模块", "知识点模块");
		},
		filters: {
			getfileType(value) {
				switch (value) {
					case "png":
						return "图片";
						break;
					case "jpg":
						return "图片";
						break;
					case null:
						return "文件夹";
						break;
					case "xlsx":
						return "excal表格";
						break;
				}
			},
		},
		methods: {
			handleRemove(file, fileList) {
				let files = this.form.matImg.split(",");
				files.splice(files.indexOf(file.url), 1);
				this.form.matImg = files.length === 0 ? "" : files.join(",");
			},
			KcFlagSunChange() {
				this.KcFlageSunId = this.KcFlagSunList[this.KcFlagFatherId][this.KcFlageSunIndex].dicId

			},
			//===================== 大活，
			closeUpdate() {
				this.resetFrom();
				this.fileList = [];
				this.dialogFormVisible = false;
			},

			null2str(data) {
				for (let x in data) {
					if (x != 'userAppealLabelIds' && x != 'userTypeLabelIds') {
						if (data[x] == null) { // 如果是null 把直接内容转为 ''
							data[x] = '';
						}
					}
				}
				return data;
			},
			// 这就写死了品类文案相关参数，上传操作了铁子
			addScattered() {

				var params = this.null2str(this.form);
				params.matStyle = this.matStyle;
				this.loading = true;
				// 数据重组
				if (params.matImg.length > 0 && params.matId == '') {
					params.matImg = params.matImg.substr(0, params.matImg.length - 1);
				}
				if (params.matId == '') {
					params.memberId = this.$store.state.memberId;
					// 新增就完事了嗷铁子
					return this.$http.post('/api/source/matScatteredMat/add', params).then(res => {
						if (res.data.status == 0) {
							this.$message.success("增加成功");
						} else {
							this.$message.error("增加失败");
						}
					}).finally(res => {
						this.dialogFormVisible = false;
						this.resetFrom();
						this.fileList = [];
						this.loading = false;
						this.getList();
					});
				}
				if (params.matId != '') {
					return this.$http.post('/api/source/matScatteredMat/update', params).then(res => {
						if (res.data.status == 0) {
							this.$message.success("修改成功");
						} else {
							this.$message.error("修改失败");
						}
					}).finally(res => {
						this.dialogFormVisible = false;
						this.resetFrom();
						this.fileList = [];
						this.loading = false;
						this.getList();
					});
				}
			},
			//=====================

			productAttrAdd() {
				// 打开增加素材的窗口
				this.resetFrom();
				this.getScatteredDicAll();
				this.fileList = [];
				this.dialogFormVisible = true;
			},
			resetFrom() {
				this.form = {
					matId: '', //素材的ID
					matImg: '', //图片或视频地址
					matInfo: '', //文案或者话术
					matVariety: '', //关联品类
					matPicType: '',
					matTextType: '',
					matRange: '',
					matStage: '',
					productId: 0, //商品ID
					matStyle: 1,
					status: 0,
					matNote: '',
				}
			},
			getScatteredDicAll() {
				this.loading = true;
				// 请求1 2 3 6 7
				var dicTypeS = [3];
				var dicTypeValue = {
					3: 181
				};
				dicTypeS.forEach(element => {
					this.$http.get("/api/source/matDic/selectByParentId?pid=" + dicTypeValue[element], {})
						.then(res => {
							switch (element) {
								case 3:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择"
									}];
									this.matVarietyList = typeList.concat(res.data.data);
									break;
							}

						}).finally(res => {});
				});
				this.loading = false;
			},
			editeMessage(item) {
				console.log(item);
				this.editeMessageItem = item
				if (item.type == "content") {
					this.$prompt('请输入内容', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputValue: item.content,
						inputValidator: (value) => {
							if (!value) {
								return '不能为空！';
							}
						},
					}).then(({
						value
					}) => {
						let url = "/api/source/clrExplain/updateExplainInfo";
						let params = {
							"deleteStatus": 0,
							"id": item.id,
							"content": value,
							"type": "content"
						};
						this.$http.post(url, params).then((res) => {
							if (res.data.status == 0) {
								this.GetExplainInfoList(this.ExplainId, this.ExplainIcon);
							} else {
								this.$message.error("发生未可知错误，请联系开发人员");
							}
						});
					}).catch(() => {

					});
				} else {
					this.drawer = true
					this.drawerType = 2
				}
			},
			//=====================
			removeMessage(id) {
				this.$confirm('此操作将删除该消息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					// 删除消息
					let url = "/api/source/clrExplain/updateExplainInfo";
					let params = {
						deleteStatus: 1,
						id: id
					};
					this.$http.post(url, params).then((res) => {
						if (res.data.status == 0) {
							this.GetExplainInfoList(this.ExplainId, this.ExplainIcon);
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
				});
			},
			GetExplainInfoList(id, icon) {
				let url = "/api/source/clrExplain/selectExplainInfo";
				let params = {
					deleteStatus: 0,
					status: 0,
					explainId: id
				};
				this.$http.post(url, params).then((res) => {
					this.ExplainId = id;
					this.ExplainIcon = icon;
					res.data.data.forEach(ele => {
						ele.type = ele.type.toLowerCase();
					})
					this.ExplainHoverList = res.data.data;
					this.ExplainHoverDiolag = true;
					// this.scrollToBottom();
				});
			},
			scrollToBottom: function() {
				this.$nextTick(function() {
					var div = document.getElementById('new_message');
					div.scrollTop = div.scrollHeight;
				})
			},
			//社群连载=========
			SelectCommunityList() {
				this.dialogType = '';
				this.dialogType = '社群';
				let url = `/api/source/clrCommunity/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
				let params = {
					deleteStatus: 0,
					kcFlag: this.searchLabel
				};
				this.$http.post(url, params).then((res) => {
					res.data.data.list.forEach(element => {
						var subString = ''
						if (element.comInfo) {
							subString = element.comInfo.length < 31 ? element.comInfo.length : 30;
							element.comInfoTitle = element.comInfo.substr(0, subString) + "......";
						} else {
							element.comInfoTitle = subString
						}

					});
					this.communityList = res.data.data.list;
				}).catch(error => {}).finally(res => {
					this.loading = false;
				});
			},
			editCommunity(row) {
				this.comLag = "update";
				this.resetCommunityForm();
				this.CommunityDialog = true;
				this.CommunityForm.id = row.id;
				this.CommunityForm.title = row.title;
				this.CommunityForm.comInfo = row.comInfo;
				this.CommunityForm.titleImg = row.titleImg;
				this.CommunityFile.push({
					url: row.titleImg
				})
				this.KcFlagFatherIndex = 0;
				this.KcFlagFatherId = 181;
				this.KcFlageSunId = row.kcFlag;
				this.KcFlagSunList[181].forEach((item, index) => {
					if (item.dicId + '' == row.kcFlag) {
						this.KcFlageSunIndex = index
					}
				})

			},

			//品类文案
			GetDocInfoList() {
				this.loading = true;
				alert("品类文案页面尚在调试，暂时可以到：素材库——图文素材管理——上传素材，选择产品种草，知识科普")
				let url = '/api/source/matScatteredMat/listPage';
				url = url + "?pageNum=" + this.pageNum + "&pageSize=" + this.pageSize;

				let params = {
					//素材形式（1）
					matStyle: 1,
					//产品种草（125）
					contentType: 125,
					//知识科普（41）
					matTextType: 41,
					status: 0
				}
				return this.$http.post(url, params).then(res => {
					this.docList = res.data.data.list;
					this.total = res.data.data.total;
				}).catch(error => {}).finally(res => {
					this.loading = false;
				});
			},


			// 发消息接口
			//上传文件 确认按钮
			handleUploadMsg(result, file) {
				if (result.status == 0) {
					var type = "";
					var filename = file.name;
					if (filename.indexOf(".") > 0) {
						type = filename.substr(filename.lastIndexOf(".") + 1);
					}
					var params = {
						type: type,
						content: result.data,
						deleteStatus: 0,
						status: 0,
						explainId: this.ExplainId
					};
					this.sendMessage(params);
				}
			},
			opendrawer(type) {
				this.drawerType = type
				this.drawer = true
			},
			sendTextMessage() {
				if (this.ExplainInfoText != '') {
					var params = {
						type: 'content',
						content: this.ExplainInfoText,
						deleteStatus: 0,
						status: 0,
						explainId: this.ExplainId
					};
					this.sendMessage(params);
				}
			},
			sendMessage(params) {
				let url = "/api/source/clrExplain/insertExplainInfo";
				this.$http.post(url, params).then((res) => {
					if (res.data.status == 0) {
						this.GetExplainInfoList(this.ExplainId, this.ExplainIcon);
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			// ==============================================营
			// ==============================================销
			// ==============================================讲
			// ==============================================解
			SelectExplainList() {
				let url = `/api/plant/clrExplain/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
				// let url = `/api/source/clrExplain/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
				let params = {
					deleteStatus: 0,
					kcFlag: this.searchLabel
				};
				this.$http.post(url, params).then((res) => {
					this.ExplainList = res.data.data.list;
					this.total = res.data.data.total
				});
			},
			InsertExplain() {
				let ExplainForm = this.ExplainForm;
				if (ExplainForm.productId == "" || ExplainForm.explainIcon == "") {
					this.$message.error("请检查信息是否输入完整")
					return false
				}
				ExplainForm.kcFlag = this.searchLabel;
				let url = `/api/plant/clrExplain/${this.czType == 0 ? 'insert' : 'update'}`
				this.$http.post(url, ExplainForm).then((res) => {
					if (res.data.status == 0) {
						this.$message.success(res.data.msg);
						this.closeExplainDialog();
						this.SelectExplainList();
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			openExplainDialog(type) {
				this.czType = 0
				this.resetExplainForm();
				this.ExplainDialog = true;
			},
			closeExplainDialog() {
				this.ExplainDialog = false;
				this.resetExplainForm();
			},
			resetExplainForm() {
				this.ExplainForm = {
					id: null,
					name: "",
					productId: null,
					productName: "",
					explainIcon: "",
					kcFlag: null,
					status: 0,
					deleteStatus: 0,
					memberId: 1,
				};
				this.KcFlagForm = {
					kcFlag: "",
					kcFlagList: [],
				}
			},

			getImg(e) {
				if (this.drawerType == 0) {
					this.ExplainForm.explainIcon = e
				}
				if (this.drawerType == 1) {
					var params = {
						content: e,
						deleteStatus: 0,
						status: 0,
						explainId: this.ExplainId,
						type: e.substring(e.length - 3)
					};
					this.sendMessage(params);
				}
				if (this.drawerType == 2) {
					var params = {
						"deleteStatus": 0,
						"id": this.editeMessageItem.id,
						"content": e,
						"type": e.substring(e.length - 3)
					};
					let url = "/api/source/clrExplain/updateExplainInfo";
					this.$http.post(url, params).then((res) => {
						if (res.data.status == 0) {
							this.GetExplainInfoList(this.ExplainId, this.ExplainIcon);
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
				}
				this.drawer = false
			},
			edites(row) {
				console.log(row);
				this.czType = 1
				this.ExplainDialog = true
				this.ExplainForm.id = row.id
				this.ExplainForm.name = row.name
				this.ExplainForm.productName = row.goodsTitle
				this.ExplainForm.explainIcon = row.explainIcon
			},
			//删除
			del(row) {
				this.$confirm('此操作将永久删除该讲解, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http
						.post("/api/source/clrExplain/update", {
							id: row.id,
							deleteStatus: 1
						})
						.then((res) => {
							if (res.data.status == 0) {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.SelectExplainList();
							} else {
								this.$message.error("删除失败");
							}
						});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//切换上下架
			changesale(id, status) {
				status = status == 0 ? 1 : 0;
				this.$http
					.post("/api/source/clrExplain/update", {
						id: id,
						status: status
					})
					.then((res) => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? "下架" : "上架";
							if (status != 0) {
								this.$message.error("已" + statusText);
							} else {
								this.$message.success("已" + statusText);
							}
							this.SelectExplainList();
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
			},

			//社群连载
			InsertCommunity() {
				let CommunityForm = this.CommunityForm;
				if (CommunityForm.title == "" || CommunityForm.titleImg == "") {
					this.$message.error("请检查信息是否输入完整")
				}
				CommunityForm.kcFlag = this.searchLabel;
				let url = "/api/source/clrCommunity/insert";
				this.$http.post(url, CommunityForm).then((res) => {
					if (res.data.status == 0) {
						this.$message.success("创建完成~");
						this.closeCommunityDialog();
						this.SelectCommunityList();
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			UpdateCommunity() {
				let CommunityForm = this.CommunityForm;

				CommunityForm.kcFlag = this.searchLabel;
				let url = "/api/source/clrCommunity/update";
				this.$http.post(url, CommunityForm).then((res) => {
					if (res.data.status == 0) {
						this.$message.success("修改成功~");
						this.closeCommunityDialog();
						this.SelectCommunityList();
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			openCommunityDialog() {
				this.comLag = "insert";
				this.resetCommunityForm();
				this.CommunityFile = [];
				this.CommunityDialog = true;
			},
			closeCommunityDialog() {
				this.CommunityDialog = false;
				this.resetCommunityForm();
			},
			resetCommunityForm() {
				this.CommunityForm = {
					id: null,
					title: "",
					comInfo: "",
					titleImg: "",
					kcFlag: null,
					status: 0,
					deleteStatus: 0,
				};
				this.KcFlagForm = {
					kcFlag: "",
					kcFlagList: [],
				}
			},


			//切换上下架
			changesale2(id, status) {
				status = status == 0 ? 1 : 0;
				this.$http
					.post("/api/source/clrCommunity/update", {
						id: id,
						status: status
					})
					.then((res) => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? "下架" : "上架";
							if (status != 0) {
								this.$message.error("已" + statusText);
							} else {
								this.$message.success("已" + statusText);
							}
							this.SelectCommunityList();
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			getPictrueURL(response, file, fileList) {
				this.ExplainForm.explainIcon = response.data;
				// if (tfileList.length != 0) {
				//     this.hide = true
				// }
			},
			getPictrueURL2(response, file, fileList) {
				this.CommunityForm.titleImg = response.data;
			},
			handleOverImage(files, fileList) {
				this.$message.error("已超出最大上传数量限制");
			},
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			// 查询商品
			searchProduct(ischange) {
				if (ischange) {
					this.pageNum2 = 1;
				}
				let url = "/api/source/matApi/findApiGoods";
				return this.$http
					.get(url, {
						params: {
							pageNum: this.pageNum2,
							pageSize: this.pageSize2,
							goodsTitle: this.keyword,
							status: "",
						},
					})
					.then((res) => {
						this.tableDataProduct = res.data.data.list;
						this.tableDataProduct.forEach((item, index) => {
							item.preview = [];
							item.preview = item.goodsLogo.split(",");
						});
						this.total2 = res.data.data.total;
					});
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				if (this.activeName == "knowledge") {
					this.getPoints(-1, 0);
				}
				if (this.activeName == "explain") {
					this.SelectExplainList();
				}
				if (this.activeName == "community") {
					this.SelectCommunityList();
				}
				if (this.activeName == "doc") {
					this.GetDocInfoList();
				}
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				if (this.activeName == "knowledge") {
					this.getPoints(-1, 0);
				}
				if (this.activeName == "explain") {
					this.SelectExplainList();
				}
				if (this.activeName == "community") {
					this.SelectCommunityList();
				}
				if (this.activeName == "doc") {
					this.GetDocInfoList();
				}
			},
			handleSizeChange2(val) {
				this.pageSize2 = val;
				this.searchProduct(false);
			},
			handleCurrentChange2(val) {
				this.pageNum2 = val;
				this.searchProduct(false);
			},
			clickProductIs(product) {
				this.ExplainForm.productId = product.id;
				this.ExplainForm.productName = product.goodsTitle;
				this.table = false;
			},
			// ==============================================知
			// ==============================================识
			// ==============================================点
			// ==============================================方
			// ==============================================法
			LabelManagement(index, type) {
				// 赋值，打开编辑的窗口。
				this.operationType = type;
				// 进行分类赋值
				let data = this.dataList[index];
				if (type == "folder") {
					// 赋值操作
					this.floter = {
						folderName: data.fileName,
						parentId: data.folderId,
						kcFlag: data.kcFlag,
						folderId: data.knowledgeId,
					};
					if (this.floter.kcFlag) {
						this.KcFlagForm.kcFlag = data.kcFlag;
						this.KcFlagForm.kcFlagList = JSON.parse(data.kcFlag);
					}
					this.openOrCloseMode();
				}
				if (type == "file") {
					this.resetKCFrom();
					this.file = {
						fileName: data.fileName,
						filePath: data.filePath,
						fileType: data.fileType,
						folderId: -1,
						kcFlag: data.kcFlag,
						knowledgeId: data.knowledgeId,
					};
					if (this.file.kcFlag) {
						this.KcFlagForm.kcFlag = data.kcFlag;
						this.KcFlagForm.kcFlagList = JSON.parse(data.kcFlag);
					}
					this.updataModes();
				}
			},
			// 获取品类的名称列表
			getP181Label(pid) {
				this.$http
					.get("/api/source/matDic/selectByParentId?pid=" + pid, {})
					.then((res) => {
						this.CategoryLabelList = [{
								dicDesc: "全部",
								dicId: 0,
								parentId: 0
							},
							...res.data.data,
						];
					});
			},
			//确认修改文件名 或者删除
			isOkEditFolderName(index, type) {
				let url = "/api/source/clrKnowledgeFolder/update";
				var data = this.dataList[index];
				var params = {
					folderId: data.knowledgeId,
					folderName: data.fileName,
					memberId: 1,
				};
				params.memberId = this.$store.state.memberId;
				if (type) {
					this.$confirm("此操作将删除该文件夹, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						params.status = 1;
						this.$http.post(url, params).then((res) => {
							if (res.data.status == 0) {
								this.$message.success("操作成功,如果看不到，请点击刷新一下");
								this.dialogVisible = false;
								this.getPoints(this.knowledgeId);
							} else {
								this.$message.error("操作失败");
							}
						});
					});
				} else {
					this.$http.post(url, params).then((res) => {
						if (res.data.status == 0) {
							this.$message.success("操作成功,如果看不到，请点击刷新一下");
							this.dialogVisible = false;
							this.getPoints(this.knowledgeId);
						} else {
							this.$message.error("操作失败");
						}
					});
				}
			},
			// 删除文件
			removeKnowlege(index) {
				this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					var data = this.dataList[index];
					let params = {
						knowledgeId: data.knowledgeId,
						status: 1,
					};
					let url = "/api/source/clrKnowledge/update";
					this.$http.post(url, params).then((res) => {
						if (res.data.status == 0) {
							this.$message.success("操作成功,如果看不到，请点击刷新一下");
							this.dialogVisible = false;
							this.getPoints(this.knowledgeId);
						} else {
							this.$message.error("操作失败");
						}
					});
				});
			},
			//文件夹重命名
			editFolder(index) {
				var arr = [...this.dataList];
				arr[index].isRename = true;
				this.dataList = arr;
			},
			//点击面包屑菜单 去往指定文件夹目录
			onIndexFolder(index) {
				var arr = [...this.breadList];
				arr.splice(index + 1);
				this.breadList = arr;
				this.getPoints(this.breadList[this.breadList.length - 1].folderId);
			},
			//查看下一层
			nextIndex(index) {
				if (this.dataList[index].fileType != null) {
					this.seeWenjian(index);
					return;
				}
				this.knowledgeId = this.dataList[index].knowledgeId;
				this.getPoints(this.dataList[index].knowledgeId, index);
			},
			//上传文件预览
			updataModes() {
				this.fileList = [];
				this.dialogVisible2 = !this.dialogVisible2;
			},
			//文件夹操作 弹框
			openOrCloseMode() {
				this.floterName = "";
				this.dialogVisible = !this.dialogVisible;
			},
			// 看文件
			seeWenjian(index) {
				var data = this.dataList[index];
				window.open(data.filePath);
			},
			//上传文件 确认按钮
			handleChange(result, file) {
				if (result.status == 0) {
					this.$message.success("上传成功，正在增加~");
					var url = "/api/source/clrKnowledge/add";
					var fileType = "";
					var filename = file.name;
					if (filename.indexOf(".") > 0) {
						fileType = filename.substr(filename.lastIndexOf(".") + 1);
					}
					var params = {
						memberId: 1,
						fileType: fileType,
						fileName: filename,
						filePath: result.data,
						knowledgeIcon: "",
						folderId: this.knowledgeId,
						status: 0,
					};
					params.memberId = this.$store.state.memberId;
					params.kcFlag = this.KcFlagForm.kcFlag;
					this.$http.post(url, params).then((res) => {
						if (res.data.status == 0) {
							this.$message.success("操作成功,如果看不到，请点击刷新一下");
						} else {
							this.$message.error("操作失败");
						}
						this.getPoints(this.knowledgeId);
					});
				}
			},
			// 新增文件夹 显示弹框
			uploadWenjian() {
				this.openOrCloseMode();
			},
			// 确认 增加文件夹
			addFloter() {
				if (!this.floter.folderName.trim()) {
					return this.$message.error("文件夹名称不能为空！！！");
				}
				if (!this.KcFlagForm.kcFlag == null) {
					return this.$message.error("请选择所属归类标签");
				}
				let floter = this.floter;
				floter.parentId = this.knowledgeId;
				floter.status = 0;
				if (floter.folderId == null) {
					floter.memberId = this.$store.state.memberId;
				}
				floter.kcFlag = this.KcFlagForm.kcFlag;
				let url = "/api/source/clrKnowledgeFolder/add";
				if (floter.folderId) {
					url = "/api/source/clrKnowledgeFolder/update";
				}
				this.$http.post(url, floter).then((res) => {
					if (res.data.status == 0) {
						this.$message.success("操作成功,如果看不到，请点击刷新一下");
						this.dialogVisible = false;
						this.resetKCFrom();
						this.getPoints(this.knowledgeId);
					} else {
						this.$message.error("操作失败");
					}
				});
			},
			// 改变上传的标签信息
			updateFileKCFlag() {
				let file = this.file;
				if (file.knowledgeId) {
					if (this.KcFlagForm.kcFlag == "") {
						this.$message.error("请选择标签");
						return;
					}
					var url = "/api/source/clrKnowledge/update";
					file.kcFlag = this.KcFlagForm.kcFlag;
					this.$http.post(url, file).then((res) => {
						if (res.data.status == 0) {
							this.$message.success("操作成功,如果看不到，请点击刷新一下");
						} else {
							this.$message.error("操作失败");
						}
						this.resetKCFrom();
						this.getPoints(this.knowledgeId);
					});
				} else {
					this.resetKCFrom();
					this.updataModes();
				}
			},
			resetKCFrom() {
				this.KcFlagForm = {
					kcFlag: "",
					kcFlagList: [],
				};
				this.floter = {
					folderName: "",
					folderId: -1,
					kcFlag: null,
					folderId: null,
				};
				this.file = {
					fileName: "",
					filePath: "",
					fileType: "",
					folderId: -1,
					kcFlag: null,
					knowledgeId: null,
				};
			},
			//  获取文件夹嗷
			getPoints(folderId, index) {
				var breadList = [...this.breadList];
				//新增文件夹没有index 所以判断一下
				if (!typeof index == "undefined" || index >= 0) {
					if (folderId == -1) {
						breadList = [{
							name: "根目录",
							folderId: -1,
						}, ];
					} else {
						breadList.push({
							name: this.dataList[index].fileName,
							folderId: this.dataList[index].knowledgeId,
						});
					}
				}
				var _this = this;
				let url = "/api/source/clrKnowledge/selectKnowledge"
				var params = {
					folderId: folderId,
				};
				if (params.folderId == -1) {
					params.kcFlag = this.searchLabel;
				}
				this.$http
					.post("/api/source/clrKnowledge/selectKnowledge?pageNum=" + this.pageNum + '&pageSize=' + this
						.pageSize, params)
					.then((res) => {
						if (res.data.status == 0) {
							res.data.data.list.forEach((element) => {
								if (element.filePath == null) {
									element.knowledgeIcon = _this.pointsImgList[0];
									element.isFolder = false;
									element.isShow = false;
									element.children = [];
									element.isRename = false; //是否显示重命名文本框
								} else {
									element.isFolder = true;
									var fileType = element.filePath.split(".");
									if (
										fileType[fileType.length - 1] == "xlsx" ||
										fileType[fileType.length - 1] == "xls"
									) {
										element.knowledgeIcon = _this.pointsImgList[1];
									}
									if (
										fileType[fileType.length - 1] == "docx" ||
										fileType[fileType.length - 1] == "doc"
									) {
										element.knowledgeIcon = _this.pointsImgList[2];
									}
									if (
										fileType[fileType.length - 1] == "pptx" ||
										fileType[fileType.length - 1] == "ppt"
									) {
										element.knowledgeIcon = _this.pointsImgList[3];
									}
									if (
										fileType[fileType.length - 1] == "jpg" ||
										fileType[fileType.length - 1] == "png"
									) {
										element.knowledgeIcon = _this.pointsImgList[4];
									}
								}
							});
							this.dataList = res.data.data.list;
							this.breadList = breadList;
						} else {
							this.$message.error("操作失败");
						}
					});

			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			//   处理列表的转换
			handleActiveClick(tage) {
				this.pageNum = 1
				this.pageSize = 100
				if (tage.name == "knowledge") {
					this.getPoints(-1, 0);
				}
				if (tage.name == "explain") {
					this.SelectExplainList();
					this.resetExplainForm();
				}
				if (tage.name == "community") {
					this.SelectCommunityList();
					this.resetCommunityForm();
				}
				if (tage.name == "doc") {
					this.GetDocInfoList();
				}
			},
			screenCategoryChange() {
				for (let i = 0; i < this.CategoryLabelList.length; i++) {
					let a = this.screenCategory;
					let b = this.CategoryLabelList[i].dicDesc.toLowerCase();
					if (b.search(a) != -1) {
						this.CategoryLabelList[i].isShow = true;
					} else {
						this.CategoryLabelList[i].isShow = false;
					}
				}
			},
			// 获取应用在知识点模块的标签
			getGroupFatherList(pid, dicMatValue, type) {
				var url = "/api/source/matDic/selectByParentId?pid=" + pid;
				if (dicMatValue) {
					url = url + "&dicMatValue=" + dicMatValue;
				}
				this.$http
					.get(url, {})
					.then((res) => {
						if (pid == -1) {
							if (type == "知识点模块") {
								this.KcFlagFatherList = res.data.data;
								this.findGroupSunList(this.KcFlagFatherList, type);
							}
						} else {
							if (type == "知识点模块") {
								this.KcFlagSunList[pid] = res.data.data;
							}
						}
					})
					.finally((res) => {});
			},
			// getSUN
			findGroupSunList(GroupFatherList, type) {
				GroupFatherList.forEach((element) => {
					this.getGroupFatherList(element.dicId, null, type);
				});
			},
			currentCategoryChange(index) {
				this.searchLabel = this.CategoryLabelList[index].dicId
				//   基本标签组形式。
				//   {fid:'父级标签ID',fname:'父级标签的名称',sid:'子标签ID',sname:'子标签名称'}
				let searchLabel = "";
				if (index != 0) {
					//   所以进行查询。直接携带ID去查询就可以。因为ID始终唯一
					searchLabel = this.CategoryLabelList[index].dicId;
				}
				this.searchLabel = searchLabel;
				//   调用查询的接口
				this.knowledgeId = -1;
				if (this.activeName == "knowledge") {
					this.getPoints(-1, 0);
				}
				if (this.activeName == "explain") {
					this.SelectExplainList();
				}
				if (this.activeName == "community") {
					this.SelectCommunityList();
				}
				if (this.activeName == "doc") {
					this.GetDocInfoList();
				}
			},
			// 扩充标签的方法
			KcFlagFatherChange() {
				this.KcFlagFatherId = this.KcFlagFatherList[this.KcFlagFatherIndex].dicId;
			},
			removeKcFlag(tag) {
				this.KcFlagForm.kcFlagList.splice(
					this.KcFlagForm.kcFlagList.indexOf(tag),
					1
				);
				this.KcFlagForm.kcFlag =
					this.KcFlagForm.kcFlagList.length == 0 ?
					"" :
					JSON.stringify(this.KcFlagForm.kcFlagList);
			},
			addKcFlag() {
				// 增加Flag
				if (
					this.KcFlagFatherIndex == null ||
					this.KcFlagFatherId == null ||
					this.KcFlageSunIndex == null
				) {
					this.$message.error("请选择标签~");
					return;
				}
				// 组装数据并填充。
				let Fitem = this.KcFlagFatherList[this.KcFlagFatherIndex];
				let Sitem = this.KcFlagSunList[this.KcFlagFatherId][this.KcFlageSunIndex];
				let meNow = {
					fid: Fitem.dicId,
					fname: Fitem.dicDesc,
					sid: Sitem.dicId,
					sname: Sitem.dicDesc,
				};
				this.KcFlagForm.kcFlagList.push(meNow);
				this.KcFlagForm.kcFlag = JSON.stringify(this.KcFlagForm.kcFlagList);
			},
		},
	};
</script>
<style scoped>
	.custom-tree-node {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.custom-tree-node span img {
		width: 20px;
	}

	.custom-tree-node span {
		align-items: center;
		display: flex;
		justify-content: center;
		font-size: 14px;
	}

	.upload-demo {
		padding-left: 10px;
	}

	.margin-left-40 {
		margin-left: 40px;
	}

	.file-box {
		width: 100%;
		display: flex;
		box-sizing: border-box;
		padding: 10px 0;
	}

	.file-box:active {
		background-color: #eee;
	}

	.file-box:nth-child(1):active {
		background-color: #fff;
	}

	.name,
	.createdtime,
	.file-type,
	.file-cz {
		flex: 1;
		font-size: 13px;
		align-items: center;
		display: flex;
	}

	.createdtime,
	.file-type,
	.file-cz {
		justify-content: center;
	}

	.name,
	.bread-item {
		cursor: pointer;
	}

	.bread-item {
		font-size: 13px;
	}

	.name img {
		width: 20px;
	}

	.el-radio.is-bordered+.el-radio.is-bordered {
		margin-left: 0px;
	}

	a {
		color: var(--cyan) !important;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.Message-list {
		height: 500px;
		background: #F5F5F5;
		border: 1px solid rgba(0, 0, 0, 0.04);
		border-radius: 0px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	/*滚动条样式*/
	.Message-list::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 8px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 8px;
	}

	.Message-list::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 4px;
		-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.Message-list::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	.Message-input {
		background: white;
		border-top: 1px solid rgba(0, 0, 0, 0.04);
		height: 150px;
	}

	.Message-shadow {
		width: 70%;
		margin-left: 15%;
		margin-right: 15%;
		margin-top: -30px;
		height: 650px;

		box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
		-webkit-box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
		-moz-box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
	}

	.Message-info {
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		margin: 3% 1%;
		width: 98%;
		overflow: hidden;
	}

	.Message-info-msg {
		padding: 10px;
		background: white;
		border-radius: 6px;
		margin-right: 10px;
		box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
		-webkit-box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
		-moz-box-shadow: 0px -14px 40px -6px rgba(0, 0, 0, 0.11);
	}

	.Message-user-icon {
		width: 40px;
		height: 40px;
		border-radius: 6px;
	}

	.Message-info-image {
		max-width: 150px;
	}

	.el-textarea__inner {
		border: unset !important;
	}

	textarea {
		border: unset !important;
	}

	/* /deep/.hide .el-upload--picture-card {
    display: none;
} */
</style>